export default {
  bookExperiencePanel: '체험 예약 패널',
  calendarIcon: '캘린더 아이콘',
  coverImageForResource: '{{title}} 체험의 표지 이미지',
  filterBy: '{{filter}}로 필터링',
  filterByDateRange: '날짜 범위로 필터링',
  gallery: '갤러리',
  goBack: '이전 페이지로 돌아가기',
  hostUserIcon: '호스트 사용자 아이콘',
  imageOf: '{{title}}의 이미지',
  interactiveMapAltText: '선택 가능한 {{title}}의 인터랙티브 맵',
  mediaSlides: '미디어 슬라이드',
  muteVideo: '비디오 음소거',
  nextPhoto: '다음 사진',
  noVideoPlayback: '비디오 재생 기능 없음',
  pauseVideo: '비디오 일시 정지',
  photoOf: '{{name}}의 사진',
  playVideo: '비디오 재생',
  previousPhoto: '이전 사진',
  moreFiltersAndExperiences: '추가 필터 및 체험',
  reserveSelectedSlot: '선택한 슬롯 예약',
  reviewRating: '5점 만점에 리뷰 평점 {{rating}}',
  overallReviewRating: '5점 만점에 전체 리뷰 평점 {{rating}}',
  selectCountryCodeForPhoneNumber: '전화번호 국가 코드 선택',
  selectDate: '날짜 선택',
  selectParticipants: '참가자 선택',
  selectSessionTime: '세션 시간 선택',
  unmuteVideo: '비디오 음소거 해제',
  viewShoppingCart: '장바구니 보기',
  itemsInCart: '{{count}} 개의 아이템이 장바구니에 있습니다',
  zoomIn: '확대',
  zoomOut: '축소',
  selectData: '{{data}} 선택',
  reserveName: '{{name}} 예약',
  deleteReservation: '{{experienceTitle}} 예약 삭제',
  editParticipantsFor: '참가자 편집 {{experienceTitle}}',
  enterPromoCode: '프로모션 코드 입력',
  applyPromoCode: '프로모션 코드 적용',
  increaseAddOnAmount: '선택한 {{addOn}} 늘리기',
  decreaseAddOnAmount: '선택한 {{addOn}} 줄이기',
  addOnModal: '{{addOn}} 모달',
  moreInformationAboutAddOn: '{{addOn}}에 대한 자세한 정보',
  decreasePriceTierTickets: '{{priceTier}} 티켓 감소',
  increasePriceTierTickets: '{{priceTier}} 티켓 증가',
  downloadFilename: '{{filename}} 다운로드',
  viewFullDetailsDescription: '전체 세부 사항 설명 보기',
  viewFullDescription: '전체 설명 보기',
  closeModal: '모달 닫기',
  hyattBanner: '월드 오브 하얏트 회원 전용 배너',
  hyattBannerDesc:
    '월드 오브 하얏트 로열티 프로그램 회원에게 제공되는 독점 혜택과 특별 제안을 알리는 프로모션 배너',
  previousSlide: '이전 슬라이드',
  nextSlide: '다음 슬라이드',
  paginationBulletMessage: '슬라이드로 이동',
  exitFullscreen: '전체 화면 모드 종료',
  enterFullscreen: '전체 화면 모드 시작',
  videoSlide: '비디오 슬라이드',
  imageSlide: '이미지 슬라이드',
  of: '의',
  noDescription: '설명 없음',
  mediaGallery: '카루셀 - 미디어 갤러리',
  dateSelector: '날짜 선택기',
  nextWeek: '다음 주',
  previousWeek: '이전 주',
  scheduleAgenda: '일정 안건',
  scheduleNav: '일정 탐색',
  scheduleViewSelector: '일정 보기 선택기',
  selectedDateAriaLabel: '{{date}}, 선택됨',
  tapToBookExperience: '{{title}} 예약',
  bookExperienceAriaLabel: '{{title}} 예약',
  joinWaitlistAriaLabel: '{{title}} 대기자 명단 가입',
};
